type BreadcrumbItem = {
  name: string;
  item: string;
};

type Props = {
  breadcrumbs: BreadcrumbItem[];
  homeUrl: string;
  includeHome?: boolean;
};

const BreadcrumbSeo = ({ breadcrumbs, homeUrl, includeHome = true }: Props) => {
  const seoItems = [
    ...(includeHome
      ? [
          {
            position: 1,
            name: 'Home',
            item: homeUrl,
          },
        ]
      : []),
    ...breadcrumbs.map((b, index) => ({
      position: includeHome ? index + 2 : index + 1,
      name: b.name,
      item: b.item,
    })),
  ];

  const jsonLdBreadcrumbs = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': seoItems.map(item => ({
      '@type': 'ListItem',
      'position': item.position,
      'name': item.name,
      'item': item.item,
    })),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdBreadcrumbs) }}
    />
  );
};

export default BreadcrumbSeo;
